module.exports = __webpack_public_path__ + "img/07.83cc1c55.png";